import { Link } from 'ui/links';
import { H3 } from 'ui/theme';
import { getIcon } from './iconHelper';
import { ErrorPageContainer } from './ErrorPage.styled';
import { ErrorPageProps } from './types';

export const ErrorPage = ({
  backText = 'Back',
  backTo = undefined,
  header,
  icon,
}: ErrorPageProps) => {
  const IconContent = getIcon(icon);

  return (
    <ErrorPageContainer>
      {IconContent && IconContent}
      {header && <H3>{header}</H3>}
      {backTo && (
        <Link useReactRouter href={backTo}>
          {backText}
        </Link>
      )}
    </ErrorPageContainer>
  );
};
